var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelecomTower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_tc)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_tc",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 20,
    height: 26,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 6,
    y: 4,
    width: 20,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5C20.9707 5 25 9.02778 25 13.9961C25 15.5923 24.582 17.09 23.8525 18.3896H23.876L19.9092 25.875C18.4675 28.5948 14.6222 28.7347 12.9863 26.127L8.48438 18.9502L8.48828 18.9492C7.54868 17.5285 7.00003 15.8267 7 13.9961C7 9.02784 11.0294 5.00009 16 5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 5C20.9707 5 25 9.02778 25 13.9961C25 15.5923 24.582 17.09 23.8525 18.3896H23.876L19.9092 25.875C18.4675 28.5948 14.6222 28.7347 12.9863 26.127L8.48438 18.9502L8.48828 18.9492C7.54868 17.5285 7.00003 15.8267 7 13.9961C7 9.02784 11.0294 5.00009 16 5Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5V4H16L16 5ZM25 13.9961L26 13.9961V13.9961H25ZM23.8525 18.3896L22.9805 17.9002L22.1445 19.3896H23.8525V18.3896ZM23.876 18.3896L24.7596 18.8579L25.5377 17.3896H23.876V18.3896ZM19.9092 25.875L20.7927 26.3434L20.7928 26.3433L19.9092 25.875ZM12.9863 26.127L12.1392 26.6583L12.1392 26.6584L12.9863 26.127ZM8.48438 18.9502L8.24184 17.9801L6.90499 18.3143L7.63725 19.4816L8.48438 18.9502ZM8.48828 18.9492L8.73082 19.9194L10.1021 19.5765L9.32237 18.3976L8.48828 18.9492ZM7 13.9961H6V13.9961L7 13.9961ZM16 5V6C20.4188 6 24 9.58046 24 13.9961H25H26C26 8.4751 21.5225 4 16 4V5ZM25 13.9961L24 13.9961C24 15.4154 23.6288 16.7452 22.9805 17.9002L23.8525 18.3896L24.7246 18.8791C25.5352 17.4348 26 15.7692 26 13.9961L25 13.9961ZM23.8525 18.3896V19.3896H23.876V18.3896V17.3896H23.8525V18.3896ZM23.876 18.3896L22.9924 17.9214L19.0256 25.4067L19.9092 25.875L20.7928 26.3433L24.7596 18.8579L23.876 18.3896ZM19.9092 25.875L19.0256 25.4066C17.9444 27.4464 15.0604 27.5515 13.8334 25.5956L12.9863 26.127L12.1392 26.6584C14.184 29.918 18.9905 29.7431 20.7927 26.3434L19.9092 25.875ZM12.9863 26.127L13.8335 25.5956L9.3315 18.4188L8.48438 18.9502L7.63725 19.4816L12.1392 26.6583L12.9863 26.127ZM8.48438 18.9502L8.72691 19.9203L8.73082 19.9194L8.48828 18.9492L8.24575 17.9791L8.24184 17.9801L8.48438 18.9502ZM8.48828 18.9492L9.32237 18.3976C8.48722 17.1348 8.00003 15.6238 8 13.9961L7 13.9961L6 13.9961C6.00004 16.0296 6.61014 17.9222 7.65419 19.5008L8.48828 18.9492ZM7 13.9961H8C8 9.58053 11.5813 6.00008 16 6L16 5L16 4C10.4775 4.0001 6 8.47514 6 13.9961H7Z",
    fill: "white",
    mask: "url(#path-1-outside-1_tc)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_tc)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 7.5,
    x2: 16,
    y2: 21,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 8.5,
    x2: 18,
    y2: 8.5,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 11,
    x2: 19,
    y2: 11,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 15.5,
    x2: 21.5,
    y2: 15.5,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 20,
    x2: 22,
    y2: 20,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 11,
    x2: 10,
    y2: 20,
    stroke: "white",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 11,
    x2: 22,
    y2: 20,
    stroke: "white",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 10.5,
    y2: 15.5,
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 21.5,
    y2: 15.5,
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_tc",
    x: 0,
    y: 0,
    width: 32,
    height: 37.0015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_tc"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_tc",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_tc"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelecomTower);
export default __webpack_public_path__ + "static/media/telecom_tower.a5dbc7a31e44e73f923458dd7dee85d8.svg";
export { ForwardRef as ReactComponent };